export const generateMessage = (message:string, ...param:string[]) => {
    let result = message
    let i = 0
    for(i=0; i < param.length; i++){
    let index = "{" + i + "}"
    result = result.replace(index,param[i])
    }
    return result
};
